import type {BaseLogger} from 'pino';

export class MockLogger implements BaseLogger {
    level = this.isDebug ? 'debug' : 'info';

    constructor(
        private readonly label: string,
        private readonly isDebug: boolean
    ) {
    }

    silent() {
    }

    trace(...args: any[]): this {
        if (this.isDebug) {
            this.write('TRC', console.log, ...args);
        }
        return this;
    }

    debug(...args: any[]): this {
        if (this.isDebug) {
            this.write('DBG', console.log, ...args);
        }
        return this;
    }

    info(...args: any[]): this {
        this.write('INF', console.log, ...args);
        return this;
    }

    warn(...args: any[]): this {
        this.write('WRN', console.log, ...args);
        return this;
    }

    error(...args: any[]): this {
        this.write('ERR', console.error, ...args);
        return this;
    }

    fatal(...args: any[]): this {
        this.write('CRT', console.error, ...args);
        return this;
    }

    private write(level: string, output: (...args: any[]) => void, ...data: any[]) {
        if (data.length && typeof data[0] !== 'string') {
            data[0] = JSON.stringify(data[0]);
        }
        output(this.getLoggerPrefix(level), this.label + ':', ...data);
    }

    private getLoggerPrefix(level: string): string {
        const date = new Date();
        const hours = date.getUTCHours().toString().padStart(2, '0');
        const minutes = date.getUTCMinutes().toString().padStart(2, '0');
        const seconds = date.getUTCSeconds().toString().padStart(2, '0');
        const ms = date.getUTCMilliseconds().toString().padStart(3, '0');

        return `${hours}:${minutes}:${seconds}.${ms} [${level}]`;
    }
}

export default function createMockLogger(label: string, isDebug: boolean): BaseLogger {
    const logger = new MockLogger(label, isDebug);
    logger.info({isDebug}, 'Created mock logger.');
    return logger;
}
